/**
 * @description generated: list of files importing the export below
 *
 * @link file://./../../pages/teach-course/routes.tsx
 */
export { default as CoachVoicePrototypeApp } from './components/CoachVoicePrototypeApp';
/**
 * @description generated: list of files importing the export below
 *
 *
 * @link file://./../../pages/teach-course/routes.tsx
 */
export const CoachVoicePrototypeAppDynamic = () => import('./components/CoachVoicePrototypeApp');
